import React from 'react'
import PropTypes from 'prop-types'
import './AppDownload.scss'
import './DarkAndLightModeSettings.scss'
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n"
import {useI18nContext} from "../i18n/I18nContext"
import Text from "../i18n/Text"
import {getAppStoreByLanguage, getPlayStoreByLanguage} from "wipi-common/src/components/LanguageImageSort";
import {CopyableCaseId} from "./CopyableCaseId";
import QRLayout from "./QRLayout";

const PLAY_STORE_URL = process.env.REACT_APP_APP_PLAY_STORE
const APP_STORE_URL = process.env.REACT_APP_APP_APPLE_STORE

export default function AppDownload({caseId, availability, illustrationDark, illustrationLight}) {
    const context = useI18nContext()
    const text = getI18nTextWithContext(context, 'eIdStart.download.pre') + 'PostIdent' +
        getI18nTextWithContext(context, 'eIdStart.download.post');

    return (
        <div className="container">
            <QRLayout caseId={caseId} illustrationDark={illustrationDark} illustrationLight={illustrationLight}/>
            <div className="row">
                <div className="col-12 col-xl-4 offset-xl-6 col-lg-5 col-md-5 offset-md-7 text-end text-muted small" data-test-id="a49f233f-e18a">
                    {availability}
                </div>
            </div>
            <div className="row">
                <div className="copy-case-id py-3">
                    <span data-test-id="14644b41-1e1c">
                        <Text k="copy.caseId"/><br/>
                    </span>
                    <CopyableCaseId caseId={caseId}/>
                </div>
            </div>
            <div className="row mt-3 col-xxl-10 col-xl-10 col-lg-10 col-md-10 col-sm-12">
                <span role="group" data-test-id="791f97c0-32e8" aria-label={text}>
                    <span aria-hidden="true">
                        {getI18nTextWithContext(context, 'eIdStart.download.pre')}
                        PostIdent
                        {getI18nTextWithContext(context, 'eIdStart.download.post')}
                    </span>
                </span>
                <div className="d-flex apps-download">
                    <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
                        <img data-test-id="186773fe-e023"
                             className="pr-1"
                             src={getAppStoreByLanguage(context.lang)}
                             alt={getI18nTextWithContext(context, 'common.piInAppStore')}
                             height="42"/>
                    </a>
                    <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
                        <img src={getPlayStoreByLanguage(context.lang)}
                             alt={getI18nTextWithContext(context, 'common.piInPlayStore')}
                             height="42"
                             data-test-id="49febda5-1be7" className="margin-right"/>
                    </a>
                </div>
            </div>
        </div>
    )
}

AppDownload.propTypes = {
    caseId: PropTypes.string.isRequired,
    illustrationDark: PropTypes.string.isRequired,
    illustrationLight: PropTypes.string.isRequired,
    availability: PropTypes.string.isRequired,
}